// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","body":"App_body__2a4FT","button":"App_button__z3Rot","rotate":"App_rotate__2Gi0M","backgroundAnimation":"App_backgroundAnimation__1Q-7o"};